import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import {
  changeFieldCostExecution,
  changeFieldMaxExecutions
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectFieldLinks,
  selectFieldCostExecution,
  selectFieldMaxExecutions,
  selectDetailsCosts,
  selectResultObject,
  selectAllErrors,
  selectSendRequestState
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import _ from 'lodash';
import OpacityPreLoaderLittle from '../../../Common/PreLoaders/OpacityPreLoaderLittle';
import TaskCardExample from './TaskCardExample';

class CostsTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.inputsRefs = {
      [props.fieldCostExecution.field]: React.createRef(),
      [props.fieldMaxExecutions.field]: React.createRef()
    };
  }

  componentDidUpdate(prevProps) {
    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      const scrollRef = this.inputsRefs[firstErrorField];
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (
      this.props.sendRequestState.countQueries >
        prevProps.sendRequestState.countQueries &&
      this.props.sendRequestState.hasSuccessQuery
    ) {
      this.props.history.push(`/my-tasks/view/${this.props.resultObject.id}`);
    }
  }

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        <article
          className="panel panel-heading_padding-large panel-footer_padding-large task_detailed panel-default"
          id="panelGroupExec"
        >
          <div className="panel-heading">
            <h2 className="panel-title">
              <i className="fa fa-rub fa-fw" /> {t('Цена, Количество, Итог')}
            </h2>
          </div>
          <div className="panel-body bg-sub border-simple-b">
            <div className="row">
              <div className="col-xs-24 col-sm-12 col-md-8">
                <div
                  className={`form-group ${
                    hasError(this.props.fieldCostExecution.errors)
                      ? 'has-error'
                      : ''
                  }`}
                >
                  <label className="control-label" htmlFor="priceForOne">
                    {t('Цена за 1 выполнение')}
                  </label>
                  <div className="input-group">
                    <input
                      ref={this.inputsRefs[this.props.fieldCostExecution.field]}
                      className="form-control ng-untouched ng-pristine ng-valid"
                      id="priceForOne"
                      name="priceForOne"
                      placeholder={t('Введите сумму')}
                      type="number"
                      value={this.props.fieldCostExecution.value}
                      onChange={e =>
                        this.props.changeFieldCostExecution(e.target.value)
                      }
                    />
                    <span className="input-group-addon">
                      <i className="fa fa-rub" />
                    </span>
                  </div>
                  {errorDesc(this.props.fieldCostExecution.errors)}
                </div>
              </div>
              <div className="col-xs-24 col-sm-12 col-md-8">
                <div
                  className={`form-group ${
                    hasError(this.props.fieldMaxExecutions.errors)
                      ? 'has-error'
                      : ''
                  }`}
                >
                  <span className="control-label control-label-light">
                    × &nbsp;
                  </span>
                  <label className="control-label" htmlFor="tryNum">
                    {t('Количество выполнений')}
                  </label>
                  <input
                    ref={this.inputsRefs[this.props.fieldMaxExecutions.field]}
                    className="form-control ng-untouched ng-pristine ng-valid"
                    id="tryNum"
                    name="tryNum"
                    placeholder={t('Введите количество')}
                    type="number"
                    value={this.props.fieldMaxExecutions.value}
                    onChange={e =>
                      this.props.changeFieldMaxExecutions(e.target.value)
                    }
                  />
                  {errorDesc(this.props.fieldMaxExecutions.errors)}
                </div>
              </div>
              <div className="col-xs-24 col-sm-24 col-md-8">
                <div className="form-group">
                  <span className="control-label control-label-light">
                    = &nbsp;
                  </span>
                  <label className="control-label" htmlFor="priceResult">
                    {t('Итого')}
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control ng-untouched ng-pristine ng-valid"
                      id="priceResult"
                      name="priceResult"
                      placeholder={t('Суммарная стоимость задания')}
                      type="number"
                      value={this.props.detailsCosts.totalSum}
                      onChange={() => {}}
                    />
                    <span className="input-group-addon">
                      <i className="fa fa-rub" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TaskCardExample
            reducerName={this.props.reducerName}
            taskId={this.props.taskId}
          />
          <div className="panel-footer pos-rel">
            {this.props.sendRequestState.hasInProgress ? (
              <OpacityPreLoaderLittle />
            ) : null}
            <div className="btn-toolbar">
              <button
                className="btn btn-primary"
                data-toggle="modal"
                type="button"
                onClick={this.props.sendForm}
              >
                {this.props.hasNewTask ? t('Создать задание') : t('Сохранить')}
              </button>
              <button
                className="btn btn-muted"
                data-target="#modalCancel"
                data-toggle="modal"
                type="button"
                onClick={e => {
                  e.preventDefault();
                  this.context.router.history.goBack();
                }}
              >
                {t('Отмена')}
              </button>
            </div>
          </div>
        </article>
      </React.Fragment>
    );
  }
}

CostsTaskInputs.contextTypes = {
  router: PropTypes.shape()
};

CostsTaskInputs.defaultProps = {
  taskId: '0000000'
};

CostsTaskInputs.propTypes = {
  // IN
  reducerName: PropTypes.string.isRequired,
  sendForm: PropTypes.func.isRequired,
  taskId: PropTypes.string,

  // CONNECT
  fieldCostExecution: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldMaxExecutions: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  fieldLinks: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.array,
    errors: PropTypes.array.isRequired
  }).isRequired,
  hasNewTask: PropTypes.bool.isRequired,
  allErrors: PropTypes.shape({}).isRequired,
  sendRequestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  detailsCosts: PropTypes.shape({
    totalSum: PropTypes.string,
    execCostForExecutor: PropTypes.string
  }).isRequired,
  resultObject: PropTypes.shape().isRequired,

  changeFieldCostExecution: PropTypes.func.isRequired,
  changeFieldMaxExecutions: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  fieldCostExecution: selectFieldCostExecution(state, props.reducerName),
  fieldMaxExecutions: selectFieldMaxExecutions(state, props.reducerName),
  fieldLinks: selectFieldLinks(state, props.reducerName),
  sendRequestState: selectSendRequestState(state, props.reducerName),
  allErrors: selectAllErrors(state, props.reducerName),
  detailsCosts: selectDetailsCosts(state, props.reducerName),
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  resultObject: selectResultObject(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldCostExecution: value =>
    dispatch(changeFieldCostExecution(props.reducerName, value)),
  changeFieldMaxExecutions: value =>
    dispatch(changeFieldMaxExecutions(props.reducerName, value))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CostsTaskInputs)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CostsTaskInputs/CostsTaskInputs.js